<template>
  <div class="sidebar-container">
    <div v-for="(item, ind) in listSubMenuReport" :key="ind">
      <!-- TITLE -->
      <div v-if="item.isTitle" class="menu-title">
        {{ item.title }}
      </div>

      <!-- MENU ITEM -->
      <div
        v-else
        :class="['menu-item', { active: isActive(item) }]"
        @click="handleClick(item)"
      >
        <feather-icon :icon="item.icon" size="18" />
        <span>{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { reportSidebarMenu } from "@/@core/utils/enum/sidebar";

export default {
  name: "ReportSidebar",
  data() {
    return {
      listSubMenuReport: reportSidebarMenu,
    };
  },
  methods: {
    handleClick(item) {
      if (!item.route) return;
      const isReportRacing = this.$route.path === "/report/regulatory/racing";
      if (isReportRacing) {
        return this.$router.push(`${item.route}?name=${item.name}`);
      }
      this.$router.push(item.route);
    },

    isActive(item) {
      if (!item.route) return false;
      const isReportRacing = this.$route.path === "/report/regulatory/racing";
      if (isReportRacing) {
        const racingName = this.$route.query.name || "";
        return item.name === racingName;
      }
      return this.$route.path === item.route;
    },
  },
};
</script>

<style scoped>
.sidebar-container {
  padding: 8px;
  overflow-y: auto;
  overscroll-behavior: contain;
  height: calc(100vh - 120px);
}
.menu-title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 16px;
  margin-bottom: 8px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.menu-item:hover {
  background: #155dfc;
  color: #fff;
}
.menu-item.active {
  background: #155dfc;
  color: #fff;
}
</style>
